'use client';

import { usePathname } from 'next/navigation';
import { useEffect, useRef } from 'react';

declare global {
  interface Window {
    _paq?: Array<Array<string | number | boolean>>;
  }
}

export function MatomoPageTracker() {
  const pathname = usePathname();
  const isFirst = useRef(true);

  useEffect(() => {
    // Skip tracking on admin routes
    if (pathname.startsWith('/d9k2m')) return;

    if (isFirst.current) {
      isFirst.current = false;
      return;
    }
    try {
      const agent = sessionStorage.getItem('ref_agent');
      const campaign = sessionStorage.getItem('ref_campaign');
      if (agent) window._paq?.push(['setCustomDimension', 1, agent]);
      if (campaign) window._paq?.push(['setCustomDimension', 2, campaign]);
    } catch { /* sessionStorage unavailable */ }
    window._paq?.push(['setCustomUrl', pathname]);
    window._paq?.push(['setDocumentTitle', document.title]);
    window._paq?.push(['trackPageView']);
  }, [pathname]);

  return null;
}
